import {
  AccountService,
  AttributesService,
  BpResourcesService,
  ClearHistoryService,
  DeviceRequestsService,
  InfectedDevicesService,
  LinesService,
  ListsService,
  LogicalDevicesService,
  ProfilesService,
  ProtectionService,
  SchedulesService,
  SSProfilesService,
  ThreatsService,
} from "@sportal/api";
import { ReportsService } from "@sportal/api/reports";

import { BaseApiService } from "../baseApiService";
import { makeListsService } from "./listService";
import { makeReportsService } from "./reportsService";
import { makeSettingsService, SBSettingsService } from "./settingsService";
import { makeThreatsService } from "./threatsService";
import { makeProfilesService } from "./profilesService";
import { makeSSService } from "./subscriberSaferyService";
import { makeScheduleService } from "./scheduleService";
import { makeDeviceRequestsService } from "./deviceRequestsService";
import { makeLinesService } from "./linesService";
import { makeInfectedDevicesService } from "./infectedDevicesService";
import { makeLogicalDevicesService } from "./logicalDevicesService";
import { makeClearHistoryService } from "./clearHistoryService";
import { makeAccountService } from "./accountService";
import { makeAttributesService } from "./attributesService";
import { makeBpResourcesService } from "./bpResourcesService";
import { makeProtectionService } from "./protectionService";
import { APIConfig } from "../api.types";

export class SsmService extends BaseApiService {
  private readonly _attributes: AttributesService;
  private readonly _list: ListsService;
  private readonly _reports: ReportsService;
  private readonly _settings: SBSettingsService;
  private readonly _account: AccountService;
  private readonly _protection: ProtectionService;
  private readonly _profiles: ProfilesService;
  private readonly _deviceRequests: DeviceRequestsService;
  private readonly _lines: LinesService;
  private readonly _infectedDevices: InfectedDevicesService;
  private readonly _logicalDevices: LogicalDevicesService;
  private readonly _threats: ThreatsService;
  private readonly _safety: SSProfilesService;
  private readonly _schedules: SchedulesService;
  private readonly _history: ClearHistoryService;
  private readonly _bpResources: BpResourcesService;

  constructor(config: APIConfig) {
    super(config);

    const { http, backendUrl } = config;
    this._attributes = makeAttributesService(http, backendUrl);
    this._list = makeListsService(http, backendUrl, config.urlFilters);
    this._reports = makeReportsService(http, config);
    this._settings = makeSettingsService(http, backendUrl);
    this._account = makeAccountService(http, backendUrl);
    this._protection = makeProtectionService(http, backendUrl);
    this._profiles = makeProfilesService(http, backendUrl);
    this._deviceRequests = makeDeviceRequestsService(http, backendUrl);
    this._lines = makeLinesService(http, backendUrl);
    this._infectedDevices = makeInfectedDevicesService(http, backendUrl);
    this._logicalDevices = makeLogicalDevicesService(http, backendUrl);
    this._threats = makeThreatsService(http, backendUrl);
    this._safety = makeSSService(http, backendUrl);
    this._schedules = makeScheduleService(http, backendUrl);
    this._history = makeClearHistoryService(http, backendUrl);
    this._bpResources = makeBpResourcesService(http, backendUrl);
  }

  get attributes(): AttributesService {
    return this._attributes;
  }

  get list(): ListsService {
    return this._list;
  }

  get reports(): ReportsService {
    return this._reports;
  }

  get settings(): SBSettingsService {
    return this._settings;
  }

  get account(): AccountService {
    return this._account;
  }

  get protection(): ProtectionService {
    return this._protection;
  }

  get profiles(): ProfilesService {
    return this._profiles;
  }

  get deviceRequests(): DeviceRequestsService {
    return this._deviceRequests;
  }

  get lines(): LinesService {
    return this._lines;
  }

  get infectedDevices(): InfectedDevicesService {
    return this._infectedDevices;
  }

  get logicalDevices(): LogicalDevicesService {
    return this._logicalDevices;
  }

  get threats(): ThreatsService {
    return this._threats;
  }

  get safety(): SSProfilesService {
    return this._safety;
  }

  get schedules(): SchedulesService {
    return this._schedules;
  }

  get history(): ClearHistoryService {
    return this._history;
  }

  get bpResources(): BpResourcesService {
    return this._bpResources;
  }
}
